import React from "react";
import { useLocation } from "react-router-dom";
import { HashLink as Link } from "react-router-hash-link";

const Nav = () => {
  const location = useLocation();

  const AtHomePage = location.pathname === "/" ? true : false;

  return (
    <div
      className={`bg-[#E5204B] w-full ${
        AtHomePage
          ? "lg:h-[287px] h-[335px] lg:pt-[45px]"
          : "h-[140px] items-center"
      } flex justify-center `}
    >
      <div className="w-[1300px] flex justify-between items-center lg:h-11 h-20 text-white py-6 px-4">
        <Link to="/">
          <div className="lg:w-[132px] lg:h-10 h-7 w-20 flex justify-center items-center">
            <img src="/Images/Logo.svg" alt="" />
          </div>
        </Link>
        <div className="flex lg:gap-[52px] gap-6 items-center font-semibold lg:text-xl text-base ">
          {AtHomePage ? (
            <>
              <Link smooth to="/#join">
                <h4>Join Flit</h4>
              </Link>
              <Link smooth to="/#why">
                <h4>Why Flit?</h4>
              </Link>
            </>
          ) : (
            <Link smooth to="/">
              <h4>Home</h4>
            </Link>
          )}
          <Link smooth to="/#faq">
            <h4>FAQs</h4>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Nav;
